import { createApiSaga } from '../../../sagaGenerator';
import {
  apiGet, apiPost, apiPut,
} from '../../../../middleware/api';
import {
  GET_VOLCANO_EVENTS_REQUEST,
  GET_VOLCANO_EVENTS_SUCCESS,
  GET_VOLCANO_EVENTS_FAILURE,
  GET_VOLCANO_EVENT_REQUEST,
  GET_VOLCANO_EVENT_SUCCESS,
  GET_VOLCANO_EVENT_FAILURE,
  UPDATE_VOLCANO_EVENT_REQUEST,
  UPDATE_VOLCANO_EVENT_SUCCESS,
  UPDATE_VOLCANO_EVENT_FAILURE,
  CREATE_VOLCANO_EVENT_REQUEST,
  CREATE_VOLCANO_EVENT_SUCCESS,
  CREATE_VOLCANO_EVENT_FAILURE,
  GET_VOLCANO_EVENT_NAME_REQUEST,
  GET_VOLCANO_EVENT_NAME_SUCCESS,
  GET_VOLCANO_EVENT_NAME_FAILURE,
  GET_VOLCANO_EVENT_MORPHOLOGY_REQUEST,
  GET_VOLCANO_EVENT_MORPHOLOGY_SUCCESS,
  GET_VOLCANO_EVENT_MORPHOLOGY_FAILURE,
  GET_VOLCANO_EVENT_COUNTRY_REQUEST,
  GET_VOLCANO_EVENT_COUNTRY_SUCCESS,
  GET_VOLCANO_EVENT_COUNTRY_FAILURE,
  GET_VOLCANO_EVENT_REGION_REQUEST,
  GET_VOLCANO_EVENT_REGION_SUCCESS,
  GET_VOLCANO_EVENT_REGION_FAILURE,
} from './volcanoEventSearchReducer';


const getVolcanoEventsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/volcanoes', ...action }),
  requestType: GET_VOLCANO_EVENTS_REQUEST,
  successType: GET_VOLCANO_EVENTS_SUCCESS,
  failureType: GET_VOLCANO_EVENTS_FAILURE,
});

const getVolcanoEventSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/volcanoes/${action.id}`, ...action }),
  requestType: GET_VOLCANO_EVENT_REQUEST,
  successType: GET_VOLCANO_EVENT_SUCCESS,
  failureType: GET_VOLCANO_EVENT_FAILURE,
});


const createVolcanoEventSaga = createApiSaga({
  apiFunction: apiPost,
  generateApiConfig: action => ({ endpoint: '/volcanoes', ...action }),
  requestType: CREATE_VOLCANO_EVENT_REQUEST,
  successType: CREATE_VOLCANO_EVENT_SUCCESS,
  failureType: CREATE_VOLCANO_EVENT_FAILURE,
  successMessage: 'Saved',
});

const updateVolcanoEventSaga = createApiSaga({
  apiFunction: apiPut,
  generateApiConfig: action => ({ endpoint: `/volcanoes/${action.id}`, ...action }),
  requestType: UPDATE_VOLCANO_EVENT_REQUEST,
  successType: UPDATE_VOLCANO_EVENT_SUCCESS,
  failureType: UPDATE_VOLCANO_EVENT_FAILURE,
  successMessage: 'Saved',
});

const getRegionsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/volcano/regions', ...action }),
  requestType: GET_VOLCANO_EVENT_REGION_REQUEST,
  successType: GET_VOLCANO_EVENT_REGION_SUCCESS,
  failureType: GET_VOLCANO_EVENT_REGION_FAILURE,
});

const getCountriesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/volcano/event-countries', ...action }),
  requestType: GET_VOLCANO_EVENT_COUNTRY_REQUEST,
  successType: GET_VOLCANO_EVENT_COUNTRY_SUCCESS,
  failureType: GET_VOLCANO_EVENT_COUNTRY_FAILURE,
});

const getVolcanoNamesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/volcano/names', ...action }),
  requestType: GET_VOLCANO_EVENT_NAME_REQUEST,
  successType: GET_VOLCANO_EVENT_NAME_SUCCESS,
  failureType: GET_VOLCANO_EVENT_NAME_FAILURE,
});

const getMorphologiesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/volcano/morphologies', ...action }),
  requestType: GET_VOLCANO_EVENT_MORPHOLOGY_REQUEST,
  successType: GET_VOLCANO_EVENT_MORPHOLOGY_SUCCESS,
  failureType: GET_VOLCANO_EVENT_MORPHOLOGY_FAILURE,
});

export const volcanoEventSearchSagas = [
  getVolcanoEventsSaga,
  getVolcanoEventSaga,
  createVolcanoEventSaga,
  updateVolcanoEventSaga,
  getRegionsSaga,
  getCountriesSaga,
  getVolcanoNamesSaga,
  getMorphologiesSaga,
];
